import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import dayjs from 'dayjs';
import Cookie from '../../../utils/Cookie';
import useAuth from '../../../hooks/useAuth';

const LandingPage = () => {
  const navigate = useNavigate();
  const { user, isInitialised } = useAuth();

  const handleUpdateUser = (userType) => {
    if (userType === 'creator') {
      Cookie.setCookie('userType', 'creator');
      navigate('/user/dashboard');
    } else {
      Cookie.setCookie('userType', 'user');
      navigate('/user/creator-list');
    }
  };

  useEffect(() => {
    if (!user) return
    if (user?.is_creator) {
      navigate('/user/dashboard')
    } else {
      navigate('/user/creator-list')
    }
  }, [user])

  return (
    <>
      <Helmet>
        <title>TLK | Talk. Real Companionship, Always.</title>
      </Helmet>
      <>
        {/* start: Get Started page */}

        <div className="main-body">
          {isInitialised ? <div className="loaderBox"><div className='loader'></div></div> :
            <>
              <div className="main-header-s1 only-text-info">
                <h1>Get Started</h1>
                <h4>Who are you?</h4>
              </div>
              <div className="body-content">
                <form className='form-content-s1'>
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <div className="form-submit-group">
                        <button type="button" onClick={() => handleUpdateUser('user')} className="gradient-btn full-size-btn">
                          <span className="text">User</span>
                        </button>
                        <button type="button" onClick={() => handleUpdateUser('creator')} className="gradient-btn full-size-btn">
                          <span className="text">Creator</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="bottom-cpx-text">
                <p>Copyright © {dayjs().format('YYYY')}, SYNTIMACY, All Rights Reserved.</p>
              </div>
            </>}
        </div>
        {/* end: Get Started page */}
      </>
    </>
  );
}

export default LandingPage;
